export default {
  lang: 'English',
  goToAldar: 'قم بزيارة aldar.com',
  actionButton: 'سجّل اهتمامك لنتصل بك',
  yasRegistrationHeading: 'احرص على ممتلكاتك الآن',
  yasRegistrationContent:
    'يسعدنا اهتمامك بياس ريفا. قم بالتسجيل للتواصل مع مديري المبيعات المخصصين لدينا، واحصل على إرشادات حول تأمين عقار أحلامك.',
  firstName: 'الاسم',
  lastName: 'الكنية',
  email: 'البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  reasonToBuy: 'سبب الشراء',
  nationality: 'الجنسية',
  residencyStatus: 'حالة الإقامة',
  reasonBuyOptionInvestor: 'استثمار',
  reasonBuyOptionHomeOwner: 'سكن',
  recieveUpdates:
    'نعم، أودّ الحصول على قائمة العقارات الفاخرة المعروضة للبيع، كما أنني مهتم بالحصول على نصائح احترافية شخصية ومعرفة أحدث تطورات السوق العقاري.',
  consentLabel: 'أوافق على',
  privacyPolicy: 'سياسة الخصوصية',
  termsAndConditions: 'شروط الاستخدام',
  consentLabelEnd: 'من الدار',
  footerContactTitle: 'تواصل معنا:',
  launchFooterContactTitle: 'نرحب بكم،',
  footerContactCallText: 'اتصل على',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'تطوير شركة الدار العقارية',
  successHeading: 'شكراً عل تسجيل اشتراكك',
  successContent:
    'يتطلع فريق مدراء مبيعاتنا للتواصل معك. ترقب رسائلنا في صندوق بريدك الإلكتروني للاطلاع على أخر التحديثات الحصرية. وإذا كنت مهتماً بمعرفة المزيد عن عروض الدار، اكتشف مرافقنا الأخرى ذات الطراز العالمي في قلب المنطقة الثقافية بجزيرة السعديات',
  successButton: 'اكتشف المزيد من المجتمعات',
  footerLink: '800 ALDAR | Aldar.com',
  contactCommentsPlaceholder: 'هل لديك أي ملاحظة أو سؤال؟',
  yasFooter: '800 ALDAR | Aldar.com',
  //====new==//
  yasWelcomeHeading: 'Where Life Meets The Water',
  yasWelcomeContent:
    'By the whispers of the waves and the glow of the golden sun lies Yas Riva, in the heart of Yas Island.',
  yasLifestyleHeading: 'LIVE THE WATERFRONT LIFESTYLE YOU DESERVE',
  yasLifestyleContent:
    'Welcome to Yas Riva, a one-of-a-kind waterfront community for the discerning few. Here, serene canals reflect the sky, and breathtaking views meet thoughtfully designed villas for those who seek exclusivity.',
  yasLuxuryHeading: 'A RESIDENCE LIKE NO OTHER',
  yasLuxuryContent:
    'Find your perfect home in a 4 to 6-bed villa inspired by the island life. Experience privilege at a whole new level with private mooring. Choose from different façade options and enjoy the flexibility of a multipurpose pod or the indulgence of a private pool—inviting you to embrace a lifestyle filled with timeless moments.',
  yasTabOneLabel: 'Amenities',
  yasTabOneHeading:
    'Bespoke amenities, where every detail is crafted for elegance.',
  yasTabOneContent: '',
  yasTabOneElement:
    '["THE VIEW CLUBHOUSE ","MEDITATION AREA ","ORTE FITNESS CENTRE","COMMUNITY MARKET ","COMMUNITY PAVILION","OUTDOOR AMPHITHEATER","JOGGING TRACK ","SAUNA ","F&B SEATING","WATER PLAY (INTERACTIVE POND) ","BBQ & PICNIC AREAS ","KIDS’ PLAY AREAS ","OUTDOOR GYM AND WORKOUT AREA","STEAM ROOM ","YOGA STUDIO ","SWIMMING POOLS (ADULTS AND KIDS) ","COMMUNITY-WIDE CYCLE TRACK ","SPA ","2 PADEL COURTS  AND TABLE TENNIS "]',
  yasTabTwoLabel: 'Sustainability',
  yasTabTwoHeading:
    'Adopting sustainable practices today for a greener community tomorrow',
  yasTabTwoContent: '',
  yasTabTwoElement:
    '["NATURAL M ATERIALS ","VILLAS TARGET A PEARL 3 RATING ","SUSTAINABLE LANDSCAPING","USE OF RECYCLED MATERIALS ","REDUCED WATER CONSUMPTION","HIGH LEVEL OF PLANT BIO-DIVERSITY.","ENERGY CONSUMPTION MONITORING"]',
  yasTabThreeLabel: 'LOCATION',
  yasTabThreeHeading:
    'Effortless access to world-class attractions on the vibrant Yas Island',
  yasTabThreeContent: '',
  yasTabThreeElement:
    '["YAS WATERWORLD","FERRARI WORLD","SEAWORLD","WARNER BROS. WORLD","YAS MARINA CIRCUIT","YAS MALL","ETIHAD ARENA","10 MINUTES TO ABU DHABI AIRPORT","30 MINUTE DRIVE TO DOWNTOWN ABU DHABI","1 HOUR DRIVE TO DUBAI"]',
  yasConclusionHeading: 'REFINED FINISHES',
  yasConclusionContent:
    'Elegance flows through every detail, offering a selection of interiors that reflect your unique style.',
  yasFooterContact: 'Contact us:',
  yasFooterCall: 'CALL 800 ALDAR',
  yasFooterPhone: '+971 2 810 6400',
  yasFooterDeveloped: 'Developed by Aldar Properties',
};
